import { useEffect, useState } from 'react';

/** Tracks a CSS media query, e.g. `useMediaQuery('(min-width: 840px)')`. */
export function useMediaQuery(query: string): boolean {
  const [matches, setMatches] = useState(
    () => typeof window !== 'undefined' && window.matchMedia(query).matches,
  );

  useEffect(() => {
    const mql = window.matchMedia(query);
    const onChange = () => setMatches(mql.matches);
    onChange();
    mql.addEventListener('change', onChange);
    return () => mql.removeEventListener('change', onChange);
  }, [query]);

  return matches;
}

/**
 * Material 3's "expanded" window class starts at 840dp. From there the home
 * screen is a list-detail layout (lists left, meeting right); below it, one
 * pane at a time with a navigation bar.
 */
export const EXPANDED_QUERY = '(min-width: 840px)';
